import { Container } from 'inversify';
import getDecorators from 'inversify-inject-decorators';

export const IocContext: { container: Container } = {
    container: new Container(),
};

const decorators = getDecorators(IocContext.container);
export const lazyInject = decorators.lazyInject;
